import MenuHeader from "../../common/MenuHeader"
import RightGoogleMap from "../../common/RightGoogleMap"
import SetUpLayout from "../../common/SetUpLayout"
import LayoutMain from "./LayoutMain"

type Props = {}

const Plant = (props: Props) => {
  return (
    <SetUpLayout
      title='Plant'

      header={
        <MenuHeader />
      }
      rightLayout={<RightGoogleMap style={{
        width: { xs: '488px' },
      }}
      />}
    >
      <LayoutMain title="Data 4 of 9" subtitle="Plants" />
    </SetUpLayout>
  )
}

export default Plant